// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./AuthStyles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--navbar-color);
  padding: 1rem 2rem;
}

.nav-brand a {
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--navbar-text);
  text-decoration: none;
}

.nav-brand a:hover {
  color: var(--navbar-text-hover);
}

.nav-links {
  display: flex;
  align-items: center;
}

.auth-links {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.nav-link {
  color: var(--navbar-text);
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all 0.2s;
}

.nav-link:hover {
  color: var(--navbar-text-hover);
  background-color: var(--navbar-color-hover);
}

.user-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.username {
  color: var(--navbar-text);
  font-weight: bold;
}

.logout-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s;
}

.logout-btn:hover {
  background-color: #c82333;
}
`, "",{"version":3,"sources":["webpack://./src/components/NavBarStyles.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import './AuthStyles.css';\n\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: var(--navbar-color);\n  padding: 1rem 2rem;\n}\n\n.nav-brand a {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--navbar-text);\n  text-decoration: none;\n}\n\n.nav-brand a:hover {\n  color: var(--navbar-text-hover);\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n}\n\n.auth-links {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.nav-link {\n  color: var(--navbar-text);\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.nav-link:hover {\n  color: var(--navbar-text-hover);\n  background-color: var(--navbar-color-hover);\n}\n\n.user-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.username {\n  color: var(--navbar-text);\n  font-weight: bold;\n}\n\n.logout-btn {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: background-color 0.2s;\n}\n\n.logout-btn:hover {\n  background-color: #c82333;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
